import React from "react";
import PropTypes from "prop-types";
import Stepper from "../stepper";

const WorkflowWizard = ({ children, title }) => {
  const childArray = React.Children.toArray(children);
  const stepCount = childArray.length;
  const step = childArray.findIndex(child => !child.props.isStepComplete);
  const childToRender = step + 1 ? childArray[step] : null;

  return (
    <>
      <Stepper title={title} total={stepCount} step={step} />
      {childToRender}
    </>
  );
};

WorkflowWizard.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default WorkflowWizard;
